import { SvgProps } from "../../types";

export const InfoIcon = ({ stroke, width, height }: SvgProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || "16"}
            height={height || "16"}
            viewBox="0 0 24 24"
            fill="none"
            stroke={stroke || "currentColor"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-info"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
        </svg>
    );
};
